angular.module('SpidApp')

.factory('TransactionSyncService', ['$http', 'SyncConfig', 'Chunker', '$q', function ($http, SyncConfig, Chunker, $q) {
  var nodeUrl = SyncConfig.Node.getURLFor('/transactions')
  var nodeAuthorization = SyncConfig.Node.Authorization
  
  var distantUrl = SyncConfig.Distant.getURLFor('/transactions')
  var distantAuthorization = SyncConfig.Distant.Authorization

  var TransactionSyncService = {
    Node: {
      getAllUnsync: function (lastSyncIsoDate) {
        if (!lastSyncIsoDate) {
          throw 'TransactionSyncService::Node::getAllUnsync() - Missing parameters'
        }

        var req = { method: 'GET', url: nodeUrl, headers: { 'Authorization': nodeAuthorization } }
        
        return $http(req).then(function (response) {
          return response.data
        }).then(function (transactions) {
          var filteredTransactions = _.filter(transactions, function (transaction) {
            return moment(transaction.updated_at).isAfter(moment(lastSyncIsoDate), 'second') // TODO
          })
          return filteredTransactions
        })
      }
    },
    Distant: {
      pushAll: function (transactions) {
          var chunked = Chunker.inConstantSizeChunks(transactions, SyncConfig.config.chunkLength)
          var p = $q(function (r) {r()})

          var pool = []
          for(var i = 0 ; i < chunked.length ; i++) {
              var data = chunked[i]
              var req = { method: 'POST', url: distantUrl, headers: { 'Authorization': distantAuthorization }, data: data }
              pool.push($http(req))
          }

          return p.then(function () {
              return $q.all(pool)
          }).then(function () {
              return {generic: 'OK'}
          })
      }
    }
  }

  return TransactionSyncService
}])